"use client";

import Script from "next/script";

const googleTagId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID as string;
const isProduction = process.env.NODE_ENV === "production";

// Add gtag to window type
declare global {
	interface Window {
		gtag: (...args: any[]) => void;
		dataLayer: any[];
	}
}

export function AnalyticsScript() {
	if (!isProduction) {
		return null;
	}

	return (
		<>
			{/* Google tag (gtag.js) */}
			<Script
				strategy="afterInteractive"
				src={`https://www.googletagmanager.com/gtag/js?id=${googleTagId}`}
			/>
			<Script id="google-analytics" strategy="afterInteractive">
				{`
					window.dataLayer = window.dataLayer || [];
					function gtag() {
						window.dataLayer.push(arguments);
					}
					window.gtag = gtag;
					gtag('js', new Date());
					gtag('config', '${googleTagId}');
				`}
			</Script>
		</>
	);
}

export function useAnalytics() {
	const trackEvent = (event: string, data?: Record<string, unknown>) => {
		if (!isProduction || typeof window === "undefined" || !window.gtag) {
			return;
		}

		window.gtag("event", event, data);
	};

	return {
		trackEvent,
	};
}
